import { cn, Skeleton } from '@mntn/ui-components'
import { ProgressSummary } from '@/components/shared'

type Props = {
  value?: number
  total?: number
  unit?: string
  formatValue?: (val: number) => string
  titleText: string
  className?: string
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const SummaryCard: React.FC<Props> = ({ titleText, className, value, total, unit, formatValue }) => {
  return (
    <div className={cn('flex flex-col gap-2 px-4 py-2', className)}>
      <ProgressSummary
        title={titleText}
        titleType="header"
        value={value}
        total={total}
        unit={unit}
        formatValue={formatValue}
      />
    </div>
  )
}

export function SummaryCardSkeleton({
  titleClassName,
  valueClassName,
}: {
  titleClassName: string
  valueClassName: string
}) {
  return (
    <div className="flex w-full min-w-0 flex-col gap-[4px] py-4 px-6">
      <Skeleton dark className={cn('h-[19px] max-w-full rounded-none', titleClassName)} />
      <Skeleton dark className={cn('h-[32px] max-w-full rounded-none', valueClassName)} />
    </div>
  )
}
